var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconStore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19,
    fill: "none",
    viewBox: "0 0 18 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    className: "accent",
    d: "M3.1 9.61v8.27h1.49v-7.52h2.62v7.52h1.51V9.6a.76.76 0 0 0-.75-.75H3.85a.76.76 0 0 0-.75.75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    className: "accent",
    fillRule: "evenodd",
    d: "M10.44 14.07h3.71c.41 0 .75-.34.75-.75V9.61a.76.76 0 0 0-.75-.75h-3.71a.76.76 0 0 0-.75.75v3.71c0 .41.34.75.75.75Zm2.96-1.5h-2.21v-2.21h2.21v2.21Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.75.5a.75.75 0 0 0-.73.58l-1 4.25a.75.75 0 0 0 .74.92v11.5c0 .41.34.75.75.75h14.97c.41 0 .75-.34.75-.75V6.25a.75.75 0 0 0 .75-.92l-1-4.25a.75.75 0 0 0-.73-.58H1.75Zm14.9 5.45a.75.75 0 0 1-.13-.28L15.66 2H2.34l-.86 3.67c-.02.1-.07.2-.13.28l.92.61V17h13.46V6.56l.92-.6Z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1.43 5.18a.75.75 0 0 0-1.36.65 3.04 3.04 0 0 0 4.75.96A3.03 3.03 0 0 0 9 6.83a3.03 3.03 0 0 0 4.13 0 3.03 3.03 0 0 0 4.8-.91.75.75 0 1 0-1.36-.65 1.54 1.54 0 0 1-2.77 0 .75.75 0 0 0-1.35 0 1.54 1.54 0 0 1-2.77 0 .75.75 0 0 0-1.36 0 1.54 1.54 0 0 1-2.7.12.75.75 0 0 0-1.42-.21 1.54 1.54 0 0 1-2.77 0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStore);
export default __webpack_public_path__ + "static/media/iconStore.2674dacd521092a4661fa5bedf521765.svg";
export { ForwardRef as ReactComponent };